var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-with-label"},[_c('button',{class:[`checkbox-with-label__checkbox--${_vm.checkboxColour}`, {active: _vm.checked }],on:{"click":_vm.toggleChecked}}),_vm._v(" "),_c('small',{staticClass:"checkbox-with-label__text",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }